// 钱包的jaspi 调用
const ua = window.navigator.userAgent.toLowerCase();

// doc: https://odocs.myoas.com/docs/RKAWVR0LBzUGWak8?mobileMsgShowStyle=1&pcMsgShowStyle=1
const rainbowBridgeInvoke = async (obj, method, options, config = {}) => {
  return new Promise((resolve) => {
    const timerId = setTimeout(() => {
      console.log('fintechUtil.js setTimeout invoke', obj, method, options);
      resolve({});
    }, 400);
    window.RainbowBridge?.invoke(
      obj,
      method,
      options,
      (res) => {
        clearTimeout(timerId);
        resolve(res.data);
        console.log(obj, method, options, 'res: ', res);
      },
      {
        loop: false,
        ...config,
      },
    );
  });
};

/**
 * 过滤掉钱包不合法的imei
 * @param {*} imei
 */
function filterImei(imei) {
  if (!/\d+/.test(imei)) {
    return '';
  }
  // 15个0
  if (imei === new Array(15).fill(0).join('')) {
    return '';
  }
  return imei;
}

export const isWallet = () =>
  (/wallet/i.test(ua) ||
    (/FinshellWebSDK/i.test(ua) && /JSBridge\/\w+ tas/i.test(ua))) &&
  !/hap/i.test(ua);
export const getToken = () =>
  rainbowBridgeInvoke('JSCommondMethod', 'getToken', {});
export const getDeviceInfo = () =>
  rainbowBridgeInvoke('JSCommondMethod', 'getDeviceInfo', {});
export const getClientContext = () =>
  rainbowBridgeInvoke('JSCommondMethod', 'getClientContext', {}).then((res) => {
    return {
      ...res,
      imei: filterImei(res?.imei),
    };
  });
export const getHeytapID = () =>
  rainbowBridgeInvoke('JSCommondMethod', 'getHeytapID', {});
// 快应用版本
export const getInstantVersion = () =>
  rainbowBridgeInvoke('JSCommondMethod', 'getHeader', { url: '' }).then(
    (res) => res?.['Ins-Ver'],
  );
